<div class="icon_header_lock">
    <app-button-secondary [isGreen]="false" [isWhite]="true" class='close' [imgUrl]="'assets/svg/plus-icon.svg'" [mat-dialog-close]="false"></app-button-secondary>
</div>
<div class='container'>
    <h1>Someone is currently editing</h1>
    <p>Only one admin can edit the application at one time</p>
    <app-button-primary text="Go back" [matDialogClose]="true"></app-button-primary>
    <!-- <app-button-secondary [isGreen]="false" [isWhite]="true" class='close' [isText]="true" [buttonText]="'go back'" [matDialogClose]="true"></app-button-secondary> -->
</div>